import { useTranslation } from 'react-i18next';

export const PollAnswerHeader = ({ isUpdateOnly }: { isUpdateOnly: boolean }) => {
    const { t } = useTranslation();

    return (
        <div className={`flex justify-between gap-x-4 text-sm font-medium ${isUpdateOnly ? '' : 'pe-13'}`}>
            <span>{t('Content.Poll.AnswerHeader')}</span>
            <span>{t('Content.Poll.PointsHeader')}</span>
        </div>
    )
};
